<div mat-dialog-title class="dialog-header">
    <h3 class="dialog-title">Job Preview</h3>
    <button mat-icon-button class="close-btn" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
</div>

<mat-dialog-content class="dialog-scroll-wrapper"
    style="background-color: rgb(247, 248, 250);scrollbar-width:none !important;margin: 0px !important;">

    <!-- <div style="text-align: end;transform: translate(8px, -6px);">
        <span class="modal-close" (click)="closeDialog()" style="cursor: pointer;"><i
                class="material-icons">close</i></span>
    </div> -->

    <div *ngIf="previewLoader" class="custom-loader custom_logo_loader ">
        <img src='../../../../../assets/images2/loader.gif' alt="loading" style="width: 10%;" />
    </div>



    <div *ngIf="!previewLoader" style="display: flex; flex-direction: column; gap: 20px; flex: 1">
        <section class="job-promoter-box" *ngIf="data?.ebanner?.url || data?.banner_image?.url">
            <img alt="" class="" [src]="data?.ebanner?.url || data?.banner_image?.url" />

        </section>

        <main class="job-details-content">
            <div class="job-details-container">
                <div class="job-header-new">
                    <div class="job-header-new__left">
                        <div class="job-header-logo">
                            <img *ngIf="data?.elogo || data?.logo" class="job-header-new__avatar"
                                [src]="data?.elogo || data?.logo" />
                        </div>
                        <div>

                            <div *ngIf="data?.jobtitle || data?.title">
                                <div class="job-header-new__label">Job Title</div>
                                <div class="job-header-new__title">
                                    {{ data?.jobtitle || data?.title }}
                                </div>
                            </div>
                            <div *ngIf="data?.erole || data?.j_role">
                                <div class="job-header-new__label">Role</div>
                                <div class="job-header-new__title">
                                    {{ data?.erole || data?.j_role }}
                                </div>
                            </div>

                            <div *ngIf="data?.ecompanyname || data?.company_name">
                                <div class="job-header-new__label">Company Name</div>
                                <div class="job-header-new__company">
                                    {{ data?.ecompanyname || data?.company_name }}
                                </div>
                            </div>

                        </div>
                    </div>

                    <div style="display: flex;flex-direction: column;">
                        <div *ngIf="data?.created_at" class="job-header-new__date">
                            Posted on:
                            {{ data?.created_at | date : "yyyy-MM-dd" }}
                        </div>

                        <div>
                            <div *ngIf="(data?.availability?.length) || data?.availability_date?.length">
                                <div class="job-header-new__label">Dates required</div>
                                <div class="job-header-new__company" style="font-size: 14px;">
                                    {{ (data?.availability?.length ? (data?.availability[0] | date:'dd-MM-yyyy') :
                                    (data?.availability_date[0] | date:'dd-MM-yyyy')) }}
                                    to
                                    {{ (data?.availability?.length ? (data?.availability[data?.availability.length - 1]
                                    |
                                    date:'dd-MM-yyyy') : (data?.availability_date[data?.availability_date.length - 1] |
                                    date:'dd-MM-yyyy')) }}
                                </div>
                            </div>

                        </div>

                    </div>

                </div>
                <div class="job-header-new__badges" *ngIf="data?.typeofemp?.length">
                    <span class="job-header-new__badge" *ngFor="let type of data?.typeofemp">{{ type }}</span>
                </div>
                <div class="job-header-new__badges" *ngIf="data?.TypeofEmployment?.length">
                    <span class="job-header-new__badge" *ngFor="let type of data?.TypeofEmployment">{{ type }}</span>
                </div>
                <!-- <div class="job-header-new__badges"
                    *ngIf="(data?.typeofemp?.length && data?.typeofemp) || data?.TypeofEmployment">
                    <span class="job-header-new__badge"
                        *ngFor="let type of (data?.typeofemp?.length ? data.typeofemp : [data.TypeofEmployment])">
                        {{ type }}
                    </span>
                </div> -->
            </div>
            <hr class="job-header-new__divider" />

            <div class="job-info-new"
                *ngIf="data?.education || data?.erangemin || data?.erangemax || data?.pay_min || data?.pay_max || data?.hiring_period || data?.ehirequick || data?.ebilling || data?.rate_billing || data?.experience || data?.years_of_experience || data?.enopeople || data?.no_of_people">
                <div class="job-info-new__item" *ngIf="data?.education">
                    <div class="job-info-new__label">Education Level</div>
                    <div class="job-info-new__value">
                        {{ data?.education }}
                    </div>
                </div>
                <!-- <div class="job-info-new__item" *ngIf="data?.erangemin || data?.erangemax ">
                    <div class="job-info-new__label">Pay</div>
                    <div class="job-info-new__value">
                        <span *ngIf="data?.erangemin">{{ data?.erangemin }} </span> - <span *ngIf="data?.erangemax"> {{
                            data?.erangemax }}</span>
                    </div>
                </div> -->
                <div class="job-info-new__item"
                    *ngIf="data?.erangemin || data?.erangemax || data?.pay_min || data?.pay_max">
                    <div class="job-info-new__label">Pay</div>
                    <div class="job-info-new__value">
                        <span *ngIf="data?.erangemin">{{ data?.erangemin }}$</span>
                        <span *ngIf="data?.pay_min">{{ data?.pay_min }}$</span>
                        <span> - </span>
                        <span *ngIf="data?.erangemax">{{ data?.erangemax }}$</span>
                        <span *ngIf="data?.pay_max">{{ data?.pay_max }}$</span>
                    </div>
                </div>

                <div class="job-info-new__item" *ngIf="data?.hiring_period || data?.ehirequick">
                    <div class="job-info-new__label">Looking for Hire</div>
                    <div class="job-info-new__value">
                        {{ data?.hiring_period || data?.ehirequick }}
                    </div>
                </div>


                <div class="job-info-new__item" *ngIf="data?.ebilling || data?.rate_billing">
                    <div class="job-info-new__label">Rate</div>
                    <div class="job-info-new__value">
                        {{ data?.ebilling || data?.rate_billing }}
                    </div>
                </div>


                <div class="job-info-new__item" *ngIf="data?.experience || data?.years_of_experience">
                    <div class="job-info-new__label">Experience Level</div>
                    <div class="job-info-new__value">
                        {{ data?.experience || data?.years_of_experience }}
                    </div>
                </div>

                <div class="job-info-new__item" *ngIf="data?.enopeople || data?.no_of_people">
                    <div class="job-info-new__label">No. Positions</div>
                    <div class="job-info-new__value">
                        {{ data?.enopeople || data?.no_of_people }}
                    </div>
                </div>

            </div>

            <hr *ngIf="data?.education || data?.erangemin || data?.erangemax || data?.pay_min || data?.pay_max || data?.hiring_period || data?.ehirequick || data?.ebilling || data?.rate_billing || data?.experience || data?.years_of_experience || data?.enopeople || data?.no_of_people"
                class="job-header-new__divider" />

            <div class="job-info-new__item" *ngIf="data?.eoffierbenefits?.length || data?.offered_benefits?.length">
                <div class="job-info-new__label">Benefits</div>
                <ul class="job-info-new__value"
                    style="list-style-type: disc !important;font-size: 17px;line-height: 30px;">
                    <li
                        *ngFor="let benefit of (data?.eoffierbenefits?.length ? data.eoffierbenefits : data.offered_benefits)">
                        {{ benefit }}
                    </li>
                </ul>
            </div>

            <hr *ngIf="data?.eoffierbenefits?.length || data?.offered_benefits?.length"
                class="job-header-new__divider" />

            <div class="job-description" *ngIf="jobDescription">
                <div class="heading">Job Description</div>
                <!-- <p style="white-space: pre-line;">{{ jobDescription }}</p> -->

                <p style="white-space: pre-line;">
                    {{ showFull ? jobDescription : (jobDescription | slice:0:150) }}{{ jobDescription.length > 150 && !showFull ? '...' : '' }}
                    <span *ngIf="jobDescription.length > 150" (click)="toggleDescription()" class="desc-see-more">
                        {{ showFull ? 'See Less' : 'See More' }}
                    </span>
                </p>

                <hr class="job-header-new__divider" />
            </div>

            <div class="job-location" *ngIf="data?.elocation || data?.location" style="position: relative;">
                <div>
                    <div class="heading">Job Location</div>
                    <p>{{ data?.elocation || data?.location }}</p>
                </div>
                <div class="viewmap">
                    <img src="assets/images/social/MapImage.png" alt=""
                        style="width:100%; height:100%; object-fit:cover;">
                    <button type="button" class="view-map-btn" (click)="openMap()">View on map</button>
                </div>

                <div class="map-popup" *ngIf="showMap" (click)="onOutsideClick($event)">
                    <div class="map-content" (click)="$event.stopPropagation()">
                        <div id="map"></div>
                    </div>
                </div>

            </div>
            <hr *ngIf="data?.elocation || data?.location" class="job-header-new__divider" />


            <!-- <div class="about-company" *ngIf="data.aboutCompanyData?.description">
                <div>About Company</div>

                <p [innerHTML]="
                    showFullAboutCom
                      ? data.aboutCompanyData?.description
                      : (data.aboutCompanyData?.description | slice:0:150) + (data.aboutCompanyData?.description?.length > 150 ? '...' : '')
                  ">
                </p>

                <span *ngIf="data.aboutCompanyData?.description?.length > 150" (click)="toggleCompanyDescription()" class="desc-see-more">
                    {{ showFullAboutCom ? 'See Less' : 'See More' }}
                </span>

                <nav *ngIf="data?.website || data?.website_url">
                    <span>For more info visit : </span>
                    <a [href]="formatUrl(data?.website)" target="_blank">
                        {{ formatUrl(data?.website) }}
                    </a>
                </nav>

                <hr class="job-header-new__divider" />
            </div> -->

            <div class="about-company"
                *ngIf="aboutComDescription">
                <div>About Company</div>

                <p style="word-break: break-word !important;"  [innerHTML]="
                    showFullAboutCom
                      ? aboutComDescription
                      : (aboutComDescription | slice:0:300) + (aboutComDescription?.length > 300 ? '...' : '')
                  ">
                </p>

                <span *ngIf="aboutComDescription?.length > 300" (click)="toggleCompanyDescription()" class="desc-see-more">
                    {{ showFullAboutCom ? 'See Less' : 'See More' }}
                </span>

                <nav *ngIf="data?.website_url">
                    <span>For more info visit : </span>
                    <a [href]="formatUrl(data?.website_url)" target="_blank">
                        {{ formatUrl(data?.website_url) }}
                    </a>
                </nav>

                <hr class="job-header-new__divider" />
            </div>




            <!-- <div class="social-media-row"> -->
            <div class="gallery-job" *ngIf=" (visibleImages && visibleImages.length > 0) ">
                <div class="gallery-job__item" >
                    <div class="gallery-job__label">Gallery</div>
                    <div class="gallery-thumbs">
                        <ng-container *ngFor="let image of visibleImages; let i = index">
                            <div class="image-wrapper" style="position: relative; display: inline-block">
                                <img [src]="image?.url" alt="" (click)="openModal(i)" style="cursor: pointer" />
                                <div *ngIf="i === 3 && remainingCount > 0" class="gallery-more-overlay"
                                    (click)="openModal(i)">
                                    +{{ remainingCount }}
                                </div>
                            </div>
                        </ng-container>
                    </div>

                    <div class="modal" *ngIf="isModalOpen">
                        <div class="modal-box">
                            <span class="close-btn-modal" (click)="closeModal()">&times;</span>
                            <img [src]="currentImage" alt="" />
                            <button class="prev" (click)="prevImage()">❮</button>
                            <button class="next" (click)="nextImage()">❯</button>
                        </div>
                    </div>
                </div>

               
            </div>

             <hr *ngIf=" (visibleImages && visibleImages.length > 0) " class="job-header-new__divider" />
             

              <!-- <div class="social-media-row"> -->
            <div class="social-media-row" *ngIf="  hasSocialMediaLinks() || data?.video || data?.videolink">
   
                <div class="social-media-row__item"
                    *ngIf="hasSocialMediaLinks()">

                    <div class="social-media-row__label">Social Media Handles</div>
                    <ul class="social-icons">

                            <a class="socialLink" style="background-color: #000 !important;" *ngIf="data?.website || data?.website_url " [href]="formatUrl(data?.website || data?.website_url ) " target="_blank">
                                <i style="color: white; font-size: x-large" class="fas fa-globe">
                                </i>
                            </a>
                    
                        <li *ngIf="data?.facebook || data?.facebook_url">
                            <a [href]="formatUrl(data?.facebook || data?.facebook_url)" target="_blank" rel="noopener">
                                <img src="../../../../../../../assets/images/social/facebook1.png" alt="Facebook" />
                            </a>
                        </li>
                        <li *ngIf="data?.instagram || data?.instagram_url">
                            <a [href]="formatUrl(data?.instagram || data?.instagram_url)" target="_blank"
                                rel="noopener">
                                <img src="../../../../../../../assets/images/social/Instagram1.png" alt="Instagram" />
                            </a>
                        </li>
                        <li *ngIf="data?.linkedin || data?.linkedin_url">
                            <a [href]="formatUrl(data?.linkedin || data?.linkedin_url)" target="_blank" rel="noopener">
                                <img src="../../../../../../../assets/images/social/LinkedIn1.png" alt="LinkedIn" />
                            </a>
                        </li>
                    </ul>
                </div>
                <!-- video -->
                <div class="social-media-row__item" *ngIf="data?.video || data?.videolink ">
                    <!-- <div class="heading">Video </div> -->
                     <div class="social-media-row__label">Video</div>
                    <!-- <p style="white-space: pre-line;">{{ jobDescription }}</p> -->
                    <div style="width: 200px;height: 150px;">

                        <app-common-url-video [url]="data?.videolink || data?.video"></app-common-url-video>

                    </div>
            
                </div>

            </div>

        </main>
    </div>

</mat-dialog-content>